var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-box flex-col flex-center"},[_c('img',{staticClass:"icon-lose",attrs:{"src":require("../../assets/images/icon-lose.svg")}}),_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.$t("home.error.216168-0")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }